import {
  getCommuneSelect,
  getCommuneSelectNew,
  getDistrictSelect,
  getProvinceSelect,
  getProvinceSelectNew,
} from "../../../service/getSelectApi";

const orderStatuses = [
  { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
  { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
  { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
  { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
  { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
  { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
  { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
];

export const warehouseStatus = [
  { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
  { value: "DANG_XUAT", label: "Đang xuất" },
  { value: "DA_XUAT", label: "Đã xuất" },
  { value: "DANG_NHAP", label: "Đang nhập" },
  { value: "DA_NHAP", label: "Đã nhập" },
];

export const orderTypes = [
  { value: "1", label: "Bán buôn", color: "yellow" },
  { value: "2", label: "Bán lẻ", color: "indigo" },
  { value: "3", label: "Đơn đổi trả", color: "green" },
  { value: "4", label: "Đơn online", color: "blue" },
];

export const dataChannel = [
  {
    text: "Lazada",
    value: "304",
  },
  {
    text: "Tiktok",
    value: "341",
  },
  {
    text: "Chat Zalo",
    value: "343",
  },
  {
    text: "Facebook",
    value: "62",
  },
  {
    text: "Shopee Mall",
    value: "63",
  },
  {
    text: "Shopee",
    value: "342",
  },
  {
    text: "Tổng đài",
    value: "66",
  },
  {
    text: "Khách đến showroom",
    value: "67",
  },
  {
    text: "Khách đặt đơn Website",
    value: "68",
  },
  {
    text: "Khách gọi điện cho nhân viên",
    value: "69",
  },
  {
    text: "Khách chat qua website",
    value: "101",
  },
];

export const getTextStatus = (row: any) => {
  return orderStatuses.find(
    (status) => status.value === row.original.orderStatus,
  )?.label;
};

export const getShippingVendorText = (shippingVendor: string) => {
  switch (shippingVendor) {
    case "KHONG":
      return "Nhận tại cửa hàng";
    case "HACOM":
      return "Nội bộ";
    default:
      return shippingVendor;
  }
};

export const handleGetInfoWarehouse = (branchId: number) => {
  const dataWarehouse = [
    {
      id: 488,
      pick_address: "Số 131 Lê Thanh Nghị , Đồng Tâm , Hai Bà Trưng , Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Hai Bà Trưng",
      pick_ward: "Đồng Tâm",
      pick_tel: "0988655130",
    },
    {
      id: 489,
      pick_address: "Số 284 Thái Hà ,Trung Liệt, Đống Đa , Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Đống Đa",
      pick_ward: "Trung Liệt",
      pick_tel: "0988655130",
    },
    {
      id: 491,
      pick_address: "Số 79 Nguyễn Văn Huyên , Quan Hoa , Cầu Giấy , Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Cầu Giấy",
      pick_ward: "Quan Hoa",
      pick_tel: "0988655130",
    },
    {
      id: 492,
      pick_address: "Số 511 Quang Trung ,Phú La, Hà Đông , Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Hà Đông",
      pick_ward: "Phú La",
      pick_tel: "0988655130",
    },
    {
      id: 494,
      pick_address: "Số 622 Nguyễn Văn Cừ ,Gia Thụy , Long Biên , Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Long Biên",
      pick_ward: "Gia Thụy",
      pick_tel: "0988655130",
    },
    {
      id: 496,
      pick_address: "CT4A Bắc Linh Đàm,Đại Kim , Hoàng Mai , Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Hoàng Mai",
      pick_ward: "Đại Kim",
      pick_tel: "0988655130",
    },
    {
      id: 221,
      pick_address: "Số 57 Trần Phú ,Văn Quán, Hà Đông , Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Hà Đông",
      pick_ward: "Văn Quán",
      pick_tel: "0988655130",
    },
    {
      id: 2701,
      pick_address: "Số 805 Giải Phóng ,Giáp Bát, Hoàng Mai , Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Hoàng Mai",
      pick_ward: "Giáp Bát",
      pick_tel: "0988655130",
    },
    {
      id: 2721,
      pick_address:
        "Số 43 Louis 8 , Hoàng Mai, Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Hoàng Mai",
      pick_ward: "Yên Sở",
      pick_tel: "0988655130",
    },
    {
      id: 2741,
      pick_address: "Số 87 Trần Duy Hưng, Trung Hòa, Cầu Giấy, Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Cầu Giấy",
      pick_ward: "Trung Hòa",
      pick_tel: "0988655130",
    },
    {
      id: 2742,
      pick_address: "Căn TMDV19, Tòa H2, Ocean Park 1, Gia Lâm, Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Gia Lâm",
      pick_ward: "Đa Tốn",
      pick_tel: "0988655130",
    },
    {
      id: 477,
      pick_address: "Số 356 Nguyễn Thị Minh Khai, Dĩnh Kế, Bắc Giang",
      pick_province: "Tỉnh Bắc Giang",
      pick_district: "Thành phố Bắc Giang",
      pick_ward: "Xã Dĩnh Kế",
      pick_tel: "0988655130",
    },
    {
      id: 478,
      pick_address: "Số 145B Trường Chinh, Phủ Lý, Hà Nam",
      pick_province: "Tỉnh Hà Nam",
      pick_district: "Thành phố Phủ Lý",
      pick_ward: "Phường Minh Khai",
      pick_tel: "0988655130",
    },
    {
      id: 479,
      pick_address: "Số 99 Lê Lợi, Thành Phố Vinh, Nghệ An",
      pick_province: "Tỉnh Nghệ An",
      pick_district: "Thành phố Vinh",
      pick_ward: "Phường Lê Lợi",
      pick_tel: "0988655130",
    },
    {
      id: 480,
      pick_address: "Số 118 Lương Ngọc Quyến, Quang Trung, Thái Nguyên",
      pick_province: "Tỉnh Thái Nguyên",
      pick_district: "Thành phố Thái Nguyên",
      pick_ward: "Phường Quang Trung",
      pick_tel: "0988655130",
    },
    {
      id: 481,
      pick_address: "Số 164 Lạc Long Quân, Đông Vệ, Thanh Hóa",
      pick_province: "Tỉnh Thanh Hóa",
      pick_district: "Thành phố Thanh Hóa",
      pick_ward: "Phường Tân Sơn",
      pick_tel: "0988655130",
    },
    {
      id: 490,
      pick_address: "Số 36 Lê Lợi, Máy Tơ, Ngô Quyền, Hải Phòng",
      pick_province: "Thành phố Hải Phòng",
      pick_district: "Quận Ngô Quyền",
      pick_ward: "Phường Máy Tơ",
      pick_tel: "0988655130",
    },
    {
      id: 493,
      pick_address: "Số 478 Cách Mạng Tháng Tám, Quận 3, Hồ Chí Minh",
      pick_province: "Thành phố Hồ Chí Minh",
      pick_district: "Quận 3",
      pick_ward: "Phường 11",
      pick_tel: "0931435431",
    },
    {
      id: 495,
      pick_address: "Số 299 Minh Khai, Từ Sơn, Bắc Ninh",
      pick_province: "Tỉnh Bắc Ninh",
      pick_district: "Thành phố Từ Sơn",
      pick_ward: "Phường Đồng Nguyên",
      pick_tel: "0988655130",
    },
    {
      id: 497,
      pick_address: "Số 35 Cao Lỗ, Đông Anh, Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Huyện Đông Anh",
      pick_ward: "Xã Uy Nỗ",
      pick_tel: "0988655130",
    },
    {
      id: 222,
      pick_address: "Số 65 Phố Thái Hà, Đống Đa, Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Quận Đống Đa",
      pick_ward: "Phường Trung Liệt",
      pick_tel: "0988655130",
    },
    {
      id: 223,
      pick_address: "Số 137 Xuân Thủy, Cầu Giấy, Hà Nội",
      pick_province: "Hà Nội",
      pick_district: "Quận Cầu Giấy",
      pick_ward: "Phường Dịch Vọng Hậu",
      pick_tel: "0988655130",
    },
    {
      id: 2761,
      pick_address: "",
      pick_province: "",
      pick_district: "",
      pick_ward: "",
      pick_tel: "0988655130",
    },
    {
      id: 2781,
      pick_address: "34 Trần Não, Phường An Khánh, Hồ Chí Minh",
      pick_province: "Hồ Chí Minh",
      pick_district: "Thủ Đức",
      pick_ward: "Phường An Khánh",
      pick_tel: "0901391682",
    },
    {
      id: 2782,
      pick_address: "783 Phan Văn Trị, Phường Hạnh Thông, Hồ Chí Minh",
      pick_province: "Hồ Chí Minh",
      pick_district: "Quận Gò Vấp",
      pick_ward: "Phường 1",
      pick_tel: "0908971358",
    },
  ];

  return dataWarehouse.find((warehouse) => warehouse.id === branchId) || null;
};

export const getNameCommune = async (districtId: string, commune: string) => {
  const getData = await getCommuneSelect(districtId);
  return getData?.find(
    (item: any) => item.value != null && item.value == commune,
  )?.text;
};

export const getNameCommuneNew = async (
  provinceId: string,
  communeId: string,
) => {
  const getData = await getCommuneSelectNew(provinceId);
  return getData?.find(
    (item: any) => item.value != null && item.value == communeId,
  )?.text;
};

export const getNameDistrict = async (
  provinceId: string,
  districtId: string,
) => {
  const getData = await getDistrictSelect(provinceId);

  return getData?.find(
    (item: any) => item.value != null && item.value == districtId,
  )?.text;
};

export const getNameProvince = async (provinceId: string) => {
  const getData = await getProvinceSelect();
  return getData?.find(
    (item: any) => item.value != null && item.value == provinceId,
  )?.text;
};

export const getNameProvinceNew = async (provinceId: string) => {
  const getData = await getProvinceSelectNew();
  return getData?.find((item: any) => item.id != null && item.id == provinceId)
    ?.name;
};
